@if (screenSize() === 'mobile') {
    <nav class="nav-mobile-left">
        <button mat-icon-button [matMenuTriggerFor]="mobileNavMenu">
            <mat-icon aria-hidden="false" aria-label="Menu" fontIcon="view_headline"></mat-icon>
        </button>
    </nav>

    <mat-menu #mobileNavMenu>
        <button mat-menu-item routerLink="">
            <mat-icon aria-hidden="false" aria-label="Home" fontIcon="home" />
            Home
        </button>
        <button mat-menu-item routerLink="/perform-module">
            <mat-icon aria-hidden="false" aria-label="Modules" fontIcon="assignment" />
            Modules
        </button>
        <button mat-menu-item routerLink="/resources">
            <mat-icon aria-hidden="false" aria-label="Resources" fontIcon="menu_book" />
            Resources
        </button>
        <button mat-menu-item (click)="router.navigate(['logout'])">
            <mat-icon aria-hidden="false" aria-label="Logout" fontIcon="logout" />
            Logout
        </button>
    </mat-menu>
} @else {
    <nav class="nav-bar">
        <div class="nav-desktop-left">
            <button
                class="nav-button"
                routerLink=""
                routerLinkActive="active"
                [routerLinkActiveOptions]="{ exact: true }"
            >
                <mat-icon aria-hidden="false" aria-label="Home" fontIcon="home" />
                Home
            </button>
            <button class="nav-button" routerLink="/perform-module" routerLinkActive="active">
                <mat-icon aria-hidden="false" aria-label="Modules" fontIcon="assignment" />
                Modules
            </button>
            <button class="nav-button" routerLink="/resources" routerLinkActive="active">
                <mat-icon aria-hidden="false" aria-label="Resources" fontIcon="menu_book" />
                Resources
            </button>
        </div>
        <div class="nav-desktop-right">
            <div class="user-container">
                <p class="welcome-message">
                    Welcome <strong>{{ userService.user()?.firstName }}</strong>
                </p>
                <button id="logout" mat-flat-button (click)="logout.emit()">
                    <mat-icon aria-hidden="false" aria-label="Logout" fontIcon="logout" />
                    Logout
                </button>
            </div>
        </div>
    </nav>
}
